import { Stack, Typography } from "@mui/material";
import React from "react";
import { SVariantDto } from "@/__generated__/sdk";
type Props = {
  variant?: SVariantDto | null;
};
export default function VariantStockAlert({ variant }: Props) {
  const stock = variant?.offer ? variant?.offer.stock : variant?.stock;

  return (
    <Stack sx={{ minHeight: 22 }} gap={2} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
      {stock && (
        <Typography variant="subtitle2" component={"section"} color={"secondary"}>
          تنها {stock} عدد در انبار باقی مانده است
        </Typography>
      )}
    </Stack>
  );
}
